<template>
<WidgetVue 
      title="Frequently Used Ngrams" 
      desc="When two or more words are juxtaposed, they are naming as 'ngrams'. Ngram analysis is good for when some concept is defined by more than one words.">
      <div id="fqk" class="ngram_holder ">
      <div class="row fqk_box">
          <ul>
            <li class="bigram" v-for="bf_item in datum.bf.slice(0, 20)" v-bind:key="bf_item">
              {{ bf_item.ngram }}
            </li>
          </ul>
        </div>
    </div>
</WidgetVue>    
</template>

<script>
import WidgetVue from "@/components/WidgetVue.vue"
export default {
  props: ["datum"],
  components: {
  WidgetVue
}
}

</script>

<style>
.bigram {
  background-color: #011b1c;
  font-weight: normal;
  
  
  color: white;
}
</style>